import { setupWorker } from 'msw/browser'; // eslint-disable-line
import handlers from './handlers';

const worker = setupWorker(...handlers);

export default worker;
